import component from './src/datepicker.vue';
export default {
  install(Vue) {
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/datepicker/index.js